export const statsData = [
    { value: "99%", label: "Applications are approved" },
    { value: "1K+", label: "Careers launched in the last year" },
    { value: "120", label: "Global university partners" },
    { value: "5", label: "Stars reviews given by satisfied clients" },
  ];